export default "__VITE_ASSET__0280c1dc__"